import { formatDate, removeTimezone } from "../utils/date";

export default class CalendarComponent extends HTMLElement {

    #resourcesService;
    #analyticsService;

    get calendarWeekElement() {
        return this.querySelector(`.v24-cal-week-heading`);
    }

    get calendarDateElement() {
        return this.querySelector(`.v24-cal-date`);
    }


    constructor() {
        super();
    }

    init(resourcesService, analyticsService) {
        this.#resourcesService = resourcesService;
        this.#analyticsService = analyticsService;
    }

    populateCalendar(html, maxAllowedDays, weekHtml) {
        this.insertAdjacentHTML("beforeend", html);
        if (this.calendarWeekElement) {
            this.calendarWeekElement.insertAdjacentHTML("beforeend", weekHtml);
        }
        if (!this.calendarDateElement) {
            window.v24SchedulerCalendar.init(this.#resourcesService , {
                parent: this,
                disablePastDays: true,
                maxAllowedDays: maxAllowedDays,
            });
        }
    }

    selectCalendarDate(date) {
        let selectedCalDate = this.querySelector(`[data-formatted-calendar-date="${date}"]`);
        if (selectedCalDate) {
            selectedCalDate.classList.add('v24-cal-date-selected');
            this.disableUnavailableCalendarDates(date);
        } else {
            console.warn("unable to set selected Date: Item doesn't exist");
        }
    }

    disableUnavailableCalendarDates(availableDate) {
        let today = removeTimezone(new Date());
        let nextAvailable = new Date(availableDate);
        
        while (today < nextAvailable) {
            let unavailableDate = this.querySelector(`[data-formatted-calendar-date="${formatDate(today)}"]`);
            if (unavailableDate) {
                this.setDisabled(unavailableDate);
            } else {
                console.warn("unable to disable previous date");
            }
            today.setDate(today.getDate() + 1);
        }
    }

    disableAllCalendarDates() {
        let calendarDates = this.querySelectorAll(`.v24-cal-date--active`);
        if (calendarDates.length > 0) {
            calendarDates.forEach((date) => {
                this.setDisabled(date);
            });
        } else {
            console.warn("unable to set disable all dates");
        }
    }

    setDisabled(date){
        date.classList.remove("v24-cal-date--active");
        date.classList.add("v24-cal-date--disabled");
        var newDateEl = date.cloneNode(true);
        date.parentNode.replaceChild(newDateEl, date);
    }
}

/*
// TODO: Add in logic for preselected options - RDM-8185
if (aptService.appointmentDate) {
    chooseAppointmentDate(aptService.appointmentDate);
    const selectedCalDate = container.querySelector(`[data-formatted-calendar-date^="${aptService.appointmentDate}"]`);
    let isSelected;
    if (selectedCalDate) {
        isSelected ? selectedCalDate.classList.add('v24-cal-date-selected') : selectedCalDate.classList.remove('v24-cal-date-selected');
    }
    aptService.appointmentDate = selectedCalDate;
} */
